// extracted by mini-css-extract-plugin
export default {"dashboardContainer":"support_dashboardContainer__86dHw","MuiGrid-item":"support_MuiGrid-item__8M3QV","MuiPaper-root":"support_MuiPaper-root__e48tf"};